export default "__VITE_ASSET__CPTDxSPl__"